import { render, staticRenderFns } from "./WeeklyReport.vue?vue&type=template&id=1ab80388&"
import script from "./WeeklyReport.vue?vue&type=script&lang=js&"
export * from "./WeeklyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports